import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faFacebookF,
	faInstagram,
	faTwitter,
} from "@fortawesome/free-brands-svg-icons";

//this is the test

function Footer() {
	return (
		<footer className="bg-gray-900 text-white py-8">
			<div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-center md:text-left">
				{/* Social Media */}
				<div>
					<h3 className="text-lg font-semibold mb-2">Social</h3>
					<div className="flex justify-center md:justify-start space-x-4">
						<a
							href="https://www.facebook.com/people/Cafe-Himalayan-Brew/100094930447837"
							aria-label="Facebook"
							className="hover:text-[#1877F2]"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FontAwesomeIcon icon={faFacebookF} />
						</a>
						<a
							href="https://www.instagram.com/cafehimalayanbrew_tuggeranong/"
							aria-label="Instagram"
							className="hover:text-pink-500"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FontAwesomeIcon icon={faInstagram} />
						</a>
					</div>
				</div>

				{/* Locations */}
				<div>
					<h3 className="text-lg font-semibold mb-2">Locations</h3>
					<div className="space-y-4">
						<div>
							<h4 className="font-medium">Tuggeranong</h4>
							<p className="text-sm">
								1-172 Anketell and, Reed St S, Greenway ACT
							</p>
							<ul className="text-xs mt-1 space-y-1">
								<li>Mon-Fri: 7:30am - 4pm</li>
								<li>Sat-Sun: 8am - 4pm</li>
							</ul>
						</div>
						<div>
							<h4 className="font-medium">Phillip</h4>
							<p className="text-sm">71 Dundas Ct, Phillip ACT 2606</p>
							<ul className="text-xs mt-1 space-y-1">
								<li>
									Mon-Fri: 6:30am - 3pm <br /> Saturday: 7:30am - 2pm.
								</li>
								<li>Sun: Closed</li>
							</ul>
						</div>
					</div>
				</div>

				{/* Contact */}
				<div>
					<h3 className="text-lg font-semibold mb-2">Contact Us</h3>
					<p className="text-sm">Email: info@cafehimalayanbrew.com</p>
					<p className="text-sm">Tuggeranong : +61 448 892 194</p>
					<p className="text-sm">Phillip : +61 449 944 088</p>
				</div>
			</div>
			<div className="mt-8 text-center text-xs text-gray-500">
				© {new Date().getFullYear()} Cafe Himalayan Brew. All Rights Reserved.
				<div className="mt-2">
					Developed by:{" "}
					<a
						href="https://ejan-portfolio.website/"
						target="_blank"
						rel="noopener noreferrer"
						className="hover:text-white"
					>
						Ejan
					</a>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
